// Spolupráce u nás (mockup „Návrat klientky“, schváleno 2. 10. 2026).
// U kontaktu, který je nebo byl klientkou: stav, trenér, lokalita, balíček, kolikrát týdně,
// od kdy do kdy a poslední trénink. Pod tím komentáře z karty klientky jen ke čtení,
// ať sales ví, proč skončila a co platí (zranění, kam má chodit).
import React, { useEffect, useState } from "react";
import { apiFetch } from "../../lib/api.js";
import { Pil } from "./salesUi.jsx";
import { dm, dmr } from "./salesApi.js";

const TON_STAVU = { "Aktivní": "ok", "Přerušeno": "pozor", "Ukončeno": "zlata" };
const inicialy = (j) => String(j || "").split(/\s+/).filter(Boolean).slice(0, 2).map((x) => x[0].toUpperCase()).join("") || "?";

export default function SpolupraceKlientky({ klientka: kl }) {
  const [komentare, setKomentare] = useState(null);
  const [vse, setVse] = useState(false);

  useEffect(() => {
    let zr = false;
    setKomentare(null); setVse(false);
    apiFetch(`/api/client-comments?klient=${encodeURIComponent(kl.jmeno)}`)
      .then((r) => (r.ok ? r.json() : { comments: [] }))
      .then((j) => {
        if (zr) return;
        const seznam = (j.comments || []).filter((c) => !c.archived && String(c.text || "").trim())
          .sort((a, b) => (b.pinned ? 1 : 0) - (a.pinned ? 1 : 0) || String(b.vytvoreno).localeCompare(String(a.vytvoreno)));
        setKomentare(seznam);
      })
      .catch(() => !zr && setKomentare([]));
    return () => { zr = true; };
  }, [kl.jmeno]);

  const obdobi = [kl.zacatek ? dmr(kl.zacatek) : "", kl.konec ? dmr(kl.konec) : ""].filter(Boolean);
  const ukazat = komentare ? (vse ? komentare : komentare.slice(0, 3)) : [];
  return (
    <section aria-label="Spolupráce u nás" className="overflow-hidden rounded-2xl border border-brand-gold/60 bg-brand-gold/10">
      <div className="flex items-center gap-2 bg-brand-gold/25 px-3.5 py-2.5">
        <span className="text-[12px] font-bold uppercase tracking-wider text-brand-950">Spolupráce u nás</span>
        <span className="ml-auto">{kl.stav && <Pil ton={TON_STAVU[kl.stav] || "neutralni"} casti={kl.stav} />}</span>
      </div>
      <div className="flex flex-wrap gap-1.5 px-3.5 py-3">
        {kl.trener && <Pil ton="znacka" casti={["trenér", kl.trener]} />}
        {kl.lokalita && <Pil ton="neutralni" casti={kl.lokalita} />}
        {(kl.balicek || kl.typ) && <Pil ton="neutralni" casti={[kl.balicek, kl.typ]} />}
        {kl.frekvence && <Pil ton="neutralni" casti={kl.frekvence} />}
        {kl.mesicu && <Pil ton="znacka" casti={`spolupracovala ${kl.mesicu} ${kl.mesicu === 1 ? "měsíc" : kl.mesicu >= 2 && kl.mesicu <= 4 ? "měsíce" : "měsíců"}`} />}
        {obdobi.length > 0 && <Pil ton="neutralni" casti={obdobi} />}
        {kl.ukonceni?.duvod_text && <Pil ton="pozor" casti={["končila", kl.ukonceni.duvod_text.toLowerCase()]} />}
        {kl.ukonceni?.poznamka && <Pil ton="neutralni" casti={`„${kl.ukonceni.poznamka}“`} />}
        {kl.posledni && <Pil ton="pozor" casti={["poslední trénink", dm(kl.posledni)]} />}
      </div>
      <div className="border-t border-brand-gold/60 bg-white">
        <div className="px-3.5 py-2 text-[12px] font-bold uppercase tracking-wider text-slate-500">Komentáře z karty klientky</div>
        {komentare === null && <div className="mx-3.5 mb-3 h-10 animate-pulse rounded-lg bg-brand-light" />}
        {komentare && !komentare.length && <div className="px-3.5 pb-3 text-[14px] text-slate-500">Žádné komentáře.</div>}
        {ukazat.map((c, i) => (
          <div key={c.id || i} className="flex gap-2.5 border-t border-slate-100 px-3.5 py-2.5">
            <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-brand-100 text-[12px] font-bold text-brand-deep">{inicialy(c.autor_name)}</span>
            <div className="min-w-0">
              <div className="text-[13px] font-bold text-slate-800">{c.autor_name || "tým"} <span className="font-medium text-slate-400">{dm(c.vytvoreno)}</span>{c.pinned && <span className="ml-1.5 font-medium text-brand-deep">připnuto</span>}</div>
              <div className="whitespace-pre-line text-[14px] leading-snug text-slate-700 [overflow-wrap:anywhere]">{c.text}</div>
            </div>
          </div>
        ))}
        {komentare && komentare.length > 3 && (
          <button type="button" className="w-full min-h-[44px] border-t border-slate-100 px-3.5 text-left text-[14px] font-bold text-brand-deep" onClick={() => setVse((x) => !x)}>
            {vse ? "Ukázat méně" : `Ukázat všechny (${komentare.length})`}
          </button>
        )}
      </div>
    </section>
  );
}
